const BASE_REELS_URL = "https://www.kerk.co.il/videos-gallery/";
// id: "5iDfVm5WHoU",
// shortsUrl: "https://www.youtube.com/shorts/5iDfVm5WHoU",
// headline: "ככה נראה מיתוג מדויק",
// subtext: "מיתוג מלא לחברת יח״צ בינלאומית: לוגו, שפה חזותית, אנימציה ואתר רספונסיבי עיצוב סאונד ועוד. הכל נבנה כאן, מדויק, חכם ומעוצב עד הפרט האחרון",
// small_regular: "לקוח: No Rumors",
// small_bold:"",
// maxTxtWidth:"230px",
// seconds: 11,


const reelSectionData = [

{    /// להבות אש רוחבי
    type: "video",
    format:  "WIDE",
    src: "/videos-gallery/leavot_esh_1000x562.mp4",
    poster: "/videos-gallery/leavot_esh_1000x562.jpg",

    headline: "הקמפיין שכבש לבבות",
    subtext: "שקט, חד, בלי רעש",
    small_regular: "קראייטיב: KERK✌️",
    small_bold:"לקוח: להבות אש",
    maxTxtWidth:"160px",
    seconds: 6,
},

{    /// נו רומרס רוחבי   
    type: "video",
    format:  "WIDE",
    src: "/videos-gallery/NoRumors_1280x720.mp4",
    poster: "/videos-gallery/NoRumors_1280x720.jpg",

    headline: "ככה נראה מיתוג מדויק",
    subtext: "מיתוג מלא לחברת יח״צ בינלאומית: לוגו, שפה חזותית, אנימציה ואתר רספונסיבי עיצוב סאונד ועוד. הכל נבנה כאן, מדויק, חכם ומעוצב עד הפרט האחרון",
    small_regular: "",
    small_bold:"No Rumors",
    maxTxtWidth:"230px",
    seconds: 11,
},

{    ///   theplace רוחבי   
    type: "video",
    format:  "WIDE",
    src: "/videos-gallery/Theplace_1280x720.mp4",
    poster: "/videos-gallery/Theplace_1280x720.jpg",

    headline: "Dating UI",
    subtext: "כמו בפגישה ראשונה, גם כאן הרושם הראשוני קובע. עיצוב שמכבד את מה שחשוב באמת",
    small_regular: "",
    small_bold:"The Places",
    maxTxtWidth:"230px",
    seconds: 6.5,
},

  {   // Kakal    רוחבי
    type: "video",
    format: "WIDE", // VERTICAL או "SQR" / "WIDE"
    src: "/videos-gallery/Kakal_1280x720_27.mp4",
    poster: "/videos-gallery/Kakal_1280x720_27.jpg",

    headline: "מוכנים לשיר ללא הפסקה?",
    subtext: `אפליקציית שירי ט"ו בשבט לקק"ל`,

    small_regular: "עיצוב אפליקציית שירים",
    small_bold:'קק"ל',
    maxTxtWidth:"160px",
    seconds: 2 ,
},

 {   // ideología   קוביה
    type: "video",
    format: "SQR", //VERTICAL או "SQR" / "WIDE"
    src: "/videos-gallery/ido_600x600_27.mp4",
    poster: "/videos-gallery/ido_600x600_27.jpg",

    headline: "ערב של השראה",
    subtext: "ideología en la vida real קמפיין עם נשמה שיצרנו לעיריית חריש ומחלקת קליטת העלייה, בערב של השראה, נשים חזקות וזהות ציונית.",
    small_regular: "עיצוב והנפשה: KERK✌️",
    small_bold:"בוצע עבור עיריית חריש",
    maxTxtWidth:"180px",
    seconds: 7,
},




 {  ///  עץ השקד קוביה  
    type: "video",
    format: "SQR", // VERTICAL או "SQR" / "WIDE"
    src: "/videos-gallery/Shaked600x600_25.mp4",
    poster: "/videos-gallery/Shaked600x600_25.jpg",
    headline: "סטנדרט העסקים החדש של הצפון",
    subtext:  "חיבור בין סאונד, תנועה וויזואליה שיוצר תחושה של יוקרה שקטה, יציבות ודינמיות מאופקת, המתאימה למרחב עסקי מודרני.",
    small_regular: "עץ השקד",
    small_bold:"הפקה: Forcemedia ",
    maxTxtWidth:"160px",
    seconds: 20,
},




{    ///  מאסטרקארד קוביה
    type: "video",
    format: "SQR", //VERTICAL או "SQR" / "WIDE"
    src: "/videos-gallery/MastercardHappyDay600x600.mp4",
    poster: "/videos-gallery/MastercardHappyDay600x600.jpg",
    headline: "Happy Mastercard Day",
    subtext: "היום הכי שווה בחודש מתקרב",
    small_regular: "Mastercard",
    small_bold:"הפקה ועיצוב: dentsu ",
    maxTxtWidth:"180px",
    seconds: 8,
},



 {   // להבות אש קוביה
    type: "video",
    format: "SQR", //VERTICAL או "SQR" / "WIDE"
    src: "/videos-gallery/leavot_esh_600x600_25.mp4",
    poster: "/videos-gallery/leavot_esh_600x600_25.jpg",

    headline: "הקמפיין שכבש לבבות",
    subtext: "שקט, חד, בלי רעש",
    small_regular: "קראייטיב: KERK✌️",
    small_bold:"להבות אש",
    maxTxtWidth:"280px",
    seconds: 7,
},







  {
///  חירש רואה עולם ורטיקל
    type: "video",
    format: "VERTICAL", // או "SQR" / "WIDE"
    src: "/videos-gallery/Hif_600x1066_30.mp4",
    poster: "/videos-gallery/Hif_600x1066_30.jpg",
    headline: "פסטיבל עלייה חריש 2025",
    subtext: "ויזואליות צבעונית שמתרגמת רב־תרבותיות לחוויה מזמינה נגישה ושמחה",
    small_regular: "עיצוב והנפשה: KERK✌️",
    small_bold:"בוצע עבור עיריית חריש",
    maxTxtWidth:"200px",
    seconds: 5,
  },

 


  {   // Kakal    ורטיקל
    type: "video",
    format: "VERTICAL", // או "SQR" / "WIDE"
    src: "/videos-gallery/Kakal_600x1066_27.mp4",
    poster: "/videos-gallery/Kakal_600x1066_27.jpg",

    headline: "מוכנים לשיר ללא הפסקה?",
    subtext: `ככה מעצבים אפליקציית שירי ט"ו בשבט`,

    small_regular: "עיצוב אפליקציית שירונים",
    small_bold:'קק"ל',
    maxTxtWidth:"180px",
    seconds: 8,
},




  {   // דודוגיימס    ורטיקל
    type: "video",
    format: "VERTICAL", // או "SQR" / "WIDE"
    src: "/videos-gallery/DuduGames_600x1066.mp4",
    poster: "/videos-gallery/DuduGames_600x1066.jpg",

    headline: "המראיין האנימטיבי הראשון",
    subtext: `ולם מונפש של משחקי מחשב, המשלב אסתטיקה רטרואית בסגנון EGA עם חיות ודינמיות מודרנית`,

     small_regular: "עיצוב והנפשה: KERK✌️",
    small_bold:   "Dudu Games",
    maxTxtWidth:"160px",
    seconds: 6.7,
},


 


  
];

export default reelSectionData;


  // {
  //   type: "image",
  //   format: "VERTICAL", // או "SQR" / "WIDE"
  //   src: "/reels/leavot_esh_1080x1920.jpg",

  //   headline: "הקמפיין שכבש לבבות",
  //   subtext: "שקט, חד, בלי רעש",
  //   small_regular: "לקוח: להבות אש",
  //   small_bold:"קראייטיב: KERK✌️",
  //   maxTxtWidth:"160px",
  //   seconds: 11,
  // },

//   {
//     id: "4cneInfwpFQ",
//     shortsUrl: "https://www.youtube.com/shorts/4cneInfwpFQ",
//     headline: "פסטיבל עלייה חריש 2025",
//     subtext: "ויזואליות צבעונית שמתרגמת רב־תרבותיות לחוויה מזמינה נגישה ושמחה ",
//     small_regular: "עיצוב והנפשה: KERK✌️",
//     small_bold:"בוצע עבור עיריית חריש",
//     maxTxtWidth:"200px",
//     seconds: 5,
//   },
//   {
//     id: "l9FQx0N_ys8",
//     shortsUrl: "https://www.youtube.com/shorts/l9FQx0N_ys8",
//     headline: "הקמפיין שכבש לבבות",
//     subtext: "שקט, חד, בלי רעש",
//    small_regular: "לקוח: להבות אש",
//     small_bold:"קראייטיב: KERK✌️",
//     maxTxtWidth:"160px",
//     seconds: 11,
//   },
 
// {
// id: "ecQ_LLOoqH4",
// shortsUrl: "https://www.youtube.com/shorts/7ri0jI7kIQ8",
// headline: "Happy Mastercard Day",
// subtext: "היום הכי שווה בחודש מתקרב",
// small_regular: "לקוח: Mastercard",
// small_bold:"הפקה ועיצוב: dentsu ",
// maxTxtWidth:"180px",
// seconds: 7,
// },
// {
// id: "5iDfVm5WHoU",
// shortsUrl: "https://www.youtube.com/shorts/5iDfVm5WHoU",
// headline: "ככה נראה מיתוג מדויק",
// subtext: "מיתוג מלא לחברת יח״צ בינלאומית: לוגו, שפה חזותית, אנימציה ואתר רספונסיבי עיצוב סאונד ועוד. הכל נבנה כאן, מדויק, חכם ומעוצב עד הפרט האחרון",
// small_regular: "לקוח: No Rumors",
// small_bold:"",
// maxTxtWidth:"230px",
// seconds: 11,
// },{
// id: "5tVrtn2TQyE",
// shortsUrl: "https://www.youtube.com/shorts/5tVrtn2TQyE",
// headline: "סטנדרט העסקים החדש של הצפון",
// subtext:  "חיבור בין סאונד, תנועה וויזואליה שיוצר תחושה של יוקרה שקטה, יציבות ודינמיות מאופקת, המתאימה למרחב עסקי מודרני.",
// small_regular: "לקוח: עץ השקד",
// small_bold:"הפקה: Forcemedia ",
// maxTxtWidth:"230px",
// seconds: 16,
// },


